module.exports = __webpack_public_path__ + "assets/img/11_674_big.edb581cf.jpg";